AFRAME.registerComponent("right-container-control", {
  schema: {},

  init: function () {
    try {
      this.root = this.el;
      if (!window.updateRightAverageVolumeGaugeFromStock) {
        window.updateRightAverageVolumeGaugeFromStock = function (stock) {
          try {
            const gauge = document.getElementById('right-average-volume');
            if (!gauge || !stock) return;
            const rvpPct = Number(stock.daypart_relative_volume_percentage);
            const payload = Number.isFinite(rvpPct)
              ? { rvp: rvpPct / 100, daypart_relative_volume_percentage: rvpPct }
              : { rvp: 0 };
            gauge.setAttribute('right-average-volume-chart', 'stockData', JSON.stringify(payload));
          } catch (e) {
            console.warn('Failed to update right-average-volume gauge:', e);
          }
        }
      }
      this.createTopMenu();
      this.createSettingsButton();
      this.createRightConfigurePopup();
      // this.createFullscreenButton();
      this.createTimelineControls();
      this.createWatchlistButton();
      this.createCompareButton();

      this.initializeStoredChartType();

      this.initializeDefaultChart();

      this.themeMode = 'Dark'
      const mainSettings = getCacheItem('mainSettings');
      if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
        this.themeMode = mainSettings.themeMode;
      } else {
        const parsed = getCacheItem('configureControlSettings');
        if (parsed && (parsed.themeMode === 'Light' || parsed.themeMode === 'Dark')) {
          this.themeMode = parsed.themeMode;
        }
      }
      this.applyTheme()
      this.setThemeChangeListener()
      this.createNoDataMessage()
      this.setupDataListeners()
    } catch (e) {
      console.error("[right-container-control] init error", e.message);
    }
  },

  createTimelineControls: function () {
    const anchor = this._getAnchor();

    const labels = [
      "1D",
      "5D",
      "1M",
      "6M",
      "YTD",
      "1Y",
      "5Y"
    ];

    const supportedIntervals = ["1D", "5D", "1M", "6M", "YTD", "1Y", "5Y"];

    const buttonWidth = 0.15;
    const buttonHeight = buttonWidth * 0.6;
    const spacing = 0.02;
    const totalWidth = labels.length * buttonWidth + (labels.length - 1) * spacing;
    const startX = -totalWidth / 2 + buttonWidth / 2;
    const y = -0.35;
    const z = 0.03;

    this.timelineButtons = [];
    this.selectedTimelineButton = null;

    labels.forEach((label, index) => {
      const x = startX + index * (buttonWidth + spacing);
      const isSupported = supportedIntervals.includes(label);
      const btn = document.createElement("a-entity");
      btn.setAttribute("ui-button", {
        label: label,
        type: "rounded-box",
        width: buttonWidth,
        height: buttonHeight,
        depth: 0.02,
        radius: 0.015,
        preferredFontSize: 0.03,
        colorScheme: "tertiary",
        autosize: false,
        isSelectable: isSupported,
        disabled: !isSupported,
      });
      btn.setAttribute("position", `${x} ${y} ${z}`);
      btn.setAttribute("data-label", label);
      btn.setAttribute("data-supported", isSupported);

      if (isSupported) {
        btn.setAttribute("data-raycastable", "");
        btn.addEventListener("click", () => {
          this.handleTimelineButtonClick(label, btn);
          
          if (window.gtag) gtag('event', `VR_RightPanel_LiveChart_TimeLine`, { period: label });
        });
      }

      anchor.appendChild(btn);
      this.timelineButtons.push(btn);
    });

    const scene = document.querySelector("a-scene");
    if (scene) {
      scene.addEventListener("data-interval", (evt) => {
        if (evt.detail && evt.detail.interval) {
          this.selectTimelineButton(evt.detail.interval);
        }
      });
      scene.addEventListener("data-interval-dividend", (evt) => {
        if (evt.detail && evt.detail.interval) {
          this.handleTimelineButtonClick(evt.detail.interval);
        }
      });
    }

    if (this.timelineButtons.length > 0) {
      setTimeout(() => {
        this.selectTimelineButton(labels[0]);
      }, 100);
    }
  },

  handleTimelineButtonClick: function (interval, button) {
    console.log(`[right-container-control] Timeline button clicked: ${interval}`);

    this.selectTimelineButton(interval);

    this.updateTradingViewInterval(interval);
  },

  selectTimelineButton: function (intervalLabel) {
    const button = this.timelineButtons.find(btn =>
      btn.getAttribute("data-label") === intervalLabel
    );

    if (!button) return;

    const isSupported = button.getAttribute("data-supported") === "true";
    if (!isSupported) {
      console.warn(`[right-container-control] Interval ${intervalLabel} is not supported`);
      return;
    }

    if (this.selectedTimelineButton && this.selectedTimelineButton !== button) {
      this.selectedTimelineButton.setAttribute("ui-button", "selected", false);
      this.selectedTimelineButton.setAttribute("scale", "1 1 1");
    }
    this.selectedTimelineButton = button;
    button.setAttribute("ui-button", "selected", true);
    button.setAttribute("scale", "1.05 1.05 1.05");

    console.log(`[right-container-control] Selected timeline button: ${intervalLabel}`);
  },

  updateTradingViewInterval: function (interval) {
    const stockChart = document.getElementById("stock-chart");
    if (!stockChart) {
      console.warn("[right-container-control] stock-chart element not found");
      return;
    }
    console.log('interval2', interval)

    const intervalMap = {
      "1D": "1d",
      "5D": "5d",
      "1M": "1m",
      "6M": "6m",
      "YTD": "ytd",
      "1Y": "1y",
      "5Y": "5y"
    };

    const mappedInterval = intervalMap[interval];

    if (!mappedInterval) {
      console.warn(`[right-container-control] Unsupported interval: ${interval}. Only 1D, 5D, and 1M are supported.`);
      return;
    }

    console.log(`[right-container-control] Updating TradingView chart interval to: ${mappedInterval}`);
    console.log(`[right-container-control] stock-chart element:`, stockChart);

    let updated = false;
    let mainChartStockData = null;

    if (stockChart && stockChart.hasAttribute("tradingview-universal-chart")) {
      const component = stockChart.components["tradingview-universal-chart"];
      const current = stockChart.getAttribute("tradingview-universal-chart") || {};
      const currentInterval = current.dataInterval;
      
      console.log(`[CHART-UPDATE] Main chart found:`, {
        hasComponent: !!component,
        hasData: !!(component && component.data),
        currentInterval: currentInterval,
        newInterval: mappedInterval,
        ticker: component?.ticker || 'unknown',
        chartType: current.type || component?.data?.type || 'mountain'
      });

      const isShortVersion = mappedInterval.toLowerCase() === '1d' && component.ticker !== 'SPY';

      if (component && component.data) {        
        mainChartStockData = component.data.stockData;
        
        const newConfig = {
          dataInterval: mappedInterval,
          stockData: mainChartStockData,
          height: component.data.height,
          type: component.data.type || current.type || 'mountain',
        };
        
        console.log(`[CHART-UPDATE] Updating main chart with config:`, {
          ...newConfig,
          stockData: typeof newConfig.stockData === 'string' ? 'string (parsed)' : 'object',
          isShortVersion: isShortVersion,
          intervalChanged: currentInterval !== mappedInterval,
          previousInterval: currentInterval
        });
        
        stockChart.setAttribute("tradingview-universal-chart", newConfig);
        
        const updatedMainAttr = stockChart.getAttribute("tradingview-universal-chart") || {};
        if (updatedMainAttr.stockData) {
          mainChartStockData = updatedMainAttr.stockData;
          console.log(`[CHART-UPDATE] Updated mainChartStockData from attribute after main chart update`);
        }
        
        setTimeout(() => {
          const updatedAttr = stockChart.getAttribute("tradingview-universal-chart") || {};
          console.log(`[CHART-UPDATE] Component state AFTER update (delayed check):`, {
            dataInterval: updatedAttr.dataInterval,
            intervalMatches: updatedAttr.dataInterval === mappedInterval
          });
        }, 100);
        
        console.log(`[CHART-UPDATE] Main chart updated successfully`);
        updated = true;
      } else {
        console.warn(`[CHART-UPDATE] Main chart component or data missing`);
      }
    } else {
      console.log(`[CHART-UPDATE] Main chart not found or doesn't have tradingview-universal-chart attribute`);
    }

    const popupStockChart = document.getElementById("popup-stock-chart");
    if (popupStockChart && popupStockChart.hasAttribute("tradingview-universal-chart")) {
      const popupComponent = popupStockChart.components["tradingview-universal-chart"];
      const popupCurrent = popupStockChart.getAttribute("tradingview-universal-chart") || {};
      
      console.log(`[CHART-UPDATE] Popup chart found:`, {
        hasComponent: !!popupComponent,
        hasData: !!(popupComponent && popupComponent.data),
        currentInterval: popupCurrent.dataInterval,
        newInterval: mappedInterval
      });
      
      if (popupComponent && popupComponent.data) {
        console.log(`[CHART-UPDATE] Popup component state BEFORE update:`, {
          currentDataInterval: popupComponent.data.dataInterval,
          currentMultiplier: popupComponent.data.multiplier,
          currentTimespan: popupComponent.data.timespan,
          currentStartDate: popupComponent.data.startDate,
          currentEndDate: popupComponent.data.endDate,
          hasStockData: !!popupComponent.data.stockData
        });

        let latestStockData = mainChartStockData;
        
        if (!latestStockData && popupComponent.data.stockData) {
          console.log(`[CHART-UPDATE] Falling back to popup's own stockData`);
          latestStockData = popupComponent.data.stockData;
        }

        const isShortVersion = mappedInterval.toLowerCase() === '1d' && popupComponent.ticker !== 'SPY';

        const popupConfig = {
          dataInterval: mappedInterval,
          stockData: latestStockData,
          height: popupComponent.data.height,
          type: popupComponent.data.type || popupCurrent.type || 'candlestick',
          width: isShortVersion ? 500 : 640,
          position: isShortVersion ? '0.1 0 0.05' : '-0.8 0 0.05',
        };
        
        console.log(`[CHART-UPDATE] Updating popup chart with config:`, {
          ...popupConfig,
          stockData: typeof popupConfig.stockData === 'string' ? 'string (parsed)' : 'object',
          isShortVersion: isShortVersion
        });
        
        popupStockChart.setAttribute("tradingview-universal-chart", popupConfig);

        console.log(`[CHART-UPDATE] Popup chart updated successfully`);
      } else {
        console.warn(`[CHART-UPDATE] Popup chart component or data missing`);
      }
    } else {
      console.log(`[CHART-UPDATE] Popup chart not found or doesn't have tradingview-universal-chart attribute`);
    }

    const is1Day = interval.toLowerCase() === '1d';
    console.log(`[CHART-UPDATE] Volume gauge update:`, {
      is1Day: is1Day,
      interval: interval
    });

    const averageVolumeBar = document.querySelector('#right-average-volume')
    if (averageVolumeBar) {
      const wasVisible = averageVolumeBar.getAttribute('visible');
      averageVolumeBar.setAttribute('visible', is1Day);
      console.log(`[CHART-UPDATE] Main volume gauge:`, {
        wasVisible: wasVisible,
        nowVisible: is1Day ? 'true' : 'false',
        changed: wasVisible !== (is1Day ? 'true' : 'false')
      });
    } else {
      console.log(`[CHART-UPDATE] Main volume gauge not found`);
    }

    const popupAverageVolumeBar = document.querySelector('#popup-right-average-volume')
    if (popupAverageVolumeBar) {
      const wasVisible = popupAverageVolumeBar.getAttribute('visible');
      popupAverageVolumeBar.setAttribute('visible', is1Day);
      console.log(`[CHART-UPDATE] Popup volume gauge:`, {
        wasVisible: wasVisible,
        nowVisible: is1Day ? 'true' : 'false',
        changed: wasVisible !== (is1Day ? 'true' : 'false')
      });
    } else {
      console.log(`[CHART-UPDATE] Popup volume gauge not found`);
    }

    console.log(`[CHART-UPDATE] Update summary:`, {
      mainChartUpdated: updated,
      popupChartExists: !!popupStockChart,
      finalInterval: mappedInterval,
      success: updated || !!popupStockChart
    });

    if (!updated && !popupStockChart) {
      console.warn("[CHART-UPDATE] No TradingView chart component found or component not initialized");
    }
    
    console.log(`[CHART-UPDATE] ==========================================`);
  },

  _getAnchor: function () {
    let anchor = this.root.querySelector('#right-controls-anchor');
    if (!anchor) {
      anchor = document.createElement('a-entity');
      anchor.setAttribute('id', 'right-controls-anchor');
      const s = this.root.object3D.scale;
      anchor.setAttribute('scale', `${1 / (s.x || 1)} ${1 / (s.y || 1)} ${1 / (s.z || 1)}`);
      const liveChartTab = this.root.querySelector('.live-chart-tab');
      if (liveChartTab) {
        liveChartTab.appendChild(anchor);
      }
    }
    return anchor;
  },

  createSettingsButton: function () {
    const anchor = this._getAnchor();

    const btn = document.createElement("a-entity");
    btn.setAttribute("ui-button", {
      image: "/vr-assets/right-container-buttons/configure.png",
      width: 0.07,
      height: 0.07,
      depth: 0.02,
      type: "rounded-box",
      colorScheme: "primary",
      radius: 0.015,
    });
    btn.classList.add('right-panel-settings-button');
    anchor.appendChild(btn);
    btn.setAttribute("position", "0.6 0.62 0.03");
    btn.addEventListener("click", () => this._toggleRightConfigurePopup());
  },

  createWatchlistButton: function () {
    const anchor = this._getAnchor();
    const buttonWidth = 0.33;
    const buttonHeight = buttonWidth * 0.3;
    const btn = document.createElement("a-entity");
    btn.setAttribute("ui-button", {
      label: "Add to watchlist",
      type: "rounded-box",
      width: buttonWidth,
      height: buttonHeight,
      depth: 0.02,
      radius: 0.015,
      preferredFontSize: 0.035,
      colorScheme: 'primary'
    });
    anchor.appendChild(btn);
    btn.setAttribute("position", "-0.42 -0.52 0.03");
    btn.addEventListener("click", () => {
      console.log('[RightPanel] Add to watchlist clicked');
      const manager = window.WatchlistApp && window.WatchlistApp.Manager;
      console.log('[RightPanel] Manager available:', manager);
      
      if (manager && manager.checkAuthorization) {
          console.log('[RightPanel] Calling checkAuthorization...');
          manager.checkAuthorization().then(result => {
              if (!result.authorized) {
                   if (window.AuthUI && window.AuthUI.showMessage) {
                       window.AuthUI.showMessage(result.message);
                   } else {
                       console.warn('AuthUI not available:', result.message);
                   }
                   return;
              }
              this._proceedAddToWatchlist();
              
              if (window.gtag) gtag('event', `VR_RightPanel_AddWatchlistButton`);
          });
      }
    });
  },

  _proceedAddToWatchlist: function() {
      const stockChart = document.getElementById("stock-chart");
      let ticker = null;
      let companyName = null;

      if (stockChart) {
        if (stockChart.components && stockChart.components['tradingview-universal-chart']) {
            const data = stockChart.components['tradingview-universal-chart'].data;
            if (data && data.stockData) {
                try {
                    const parsed = typeof data.stockData === 'string' ? JSON.parse(data.stockData) : data.stockData;
                    ticker = parsed.ticker;
                    if (parsed.tickerDetails) companyName = parsed.tickerDetails.name;
                } catch(e) { console.warn("Error parsing stockData from component", e); }
            }
        }
        if (!ticker && stockChart.hasAttribute('tradingview-universal-chart')) {
          try {
            const attrVal = stockChart.getAttribute('tradingview-universal-chart');
            const dataStr = attrVal.stockData;
            if (dataStr) {
              const data = typeof dataStr === 'string' ? JSON.parse(dataStr) : dataStr;
              ticker = data.ticker;
              if (data.tickerDetails) companyName = data.tickerDetails.name;
            }
          } catch (e) { console.warn("Error parsing stock data from attribute", e); }
        }
      }

      if (ticker && window.WatchlistApp) {
          const Manager = window.WatchlistApp.Manager;
          const State = window.WatchlistApp.State;
          
          if (Manager && State) {
              const isPremium = Manager.isPremiumUser ? Manager.isPremiumUser() : false;
              let count = 0;
              if (State.currentWatchlistData) {
                  count = Array.isArray(State.currentWatchlistData) ? State.currentWatchlistData.length : Object.keys(State.currentWatchlistData).length;
              }
              
              const MAX_ITEMS_FREE = 50; 

              if (!isPremium && count >= MAX_ITEMS_FREE) {
                   if (window.WatchlistApp.Popup && window.WatchlistApp.Popup.showPremiumLimitPopup) {
                       window.WatchlistApp.Popup.showPremiumLimitPopup(
                           "Unlimited stocks in watchlist are coming soon!",
                           `Adding more than ${MAX_ITEMS_FREE} assets is a Pro feature currently in development.`
                       );
                   }
                   return;
              }
          }
      }
      if (ticker) {
        if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showAddToWatchlistPopup) {
          window.WatchlistApp.Popup.showAddToWatchlistPopup(ticker, companyName);
        } else {
          console.warn("WatchlistApp.Popup.showAddToWatchlistPopup not available");
        }
      } else {
         if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
             window.WatchlistApp.Popup.showNotificationPopup("No Stock Selected", "Please select a stock first.");
         }
      }
  },

  createCompareButton: function () {
    const anchor = this._getAnchor();
    const buttonWidth = 0.33;
    const buttonHeight = buttonWidth * 0.3;
    const btn = document.createElement("a-entity");
    btn.setAttribute("ui-button", {
      label: "Compare",
      type: "rounded-box",
      width: buttonWidth,
      height: buttonHeight,
      depth: 0.02,
      radius: 0.015,
      preferredFontSize: 0.035,
      colorScheme: 'primary',
    });
    anchor.appendChild(btn);
    btn.setAttribute("position", "0.45 -0.52 0.03");
  },

  createTopMenu: function () {
    const anchor = this.el.querySelector('.main-header')
    if (!anchor) return

    const buttonLabels = [
      "Live Chart",
      "Performance",
      "Profile",
      "Financials",
    ];

    const buttonWidth = 0.25;
    const buttonHeight = buttonWidth * 0.4;
    const spacing = 0.02;

    const startX = - 0.46;
    const startY = 0.84;
    const z = 0.03;

    this.topMenuButtons = [];

    const selectButton = (buttonEl, currentIndex) => {
      const financialsTab = this.el.querySelector('.financials-tab');
      const financialsComponent = financialsTab && financialsTab.components
        ? financialsTab.components['financials-tab']
        : null;

      if (currentIndex !== 3 && financialsComponent && financialsComponent.isExpanded) {
        financialsComponent.collapseFinancialsPanel();
      }

      this.topMenuButtons.forEach((btn) => {
        if (btn && btn !== buttonEl) {
          btn.setAttribute("ui-button", "selected", false);
          btn.setAttribute("scale", "1 1 1");
        }
      });
      buttonEl.setAttribute("ui-button", "selected", true);
      buttonEl.setAttribute("scale", "1.05 1.05 1.05");

      //
      const tabsArr = [
        this.el.querySelector('.live-chart-tab'),
        this.el.querySelector('.performance-tab'),
        this.el.querySelector('.profile-tab'),
        this.el.querySelector('.financials-tab')
      ]
      tabsArr.forEach((tab, tabIndex) => {
        if (tab) {
          tab.setAttribute("visible", currentIndex === tabIndex);
          if (tabIndex === 0) {
            tab.setAttribute("position", currentIndex === tabIndex ? "0 0 0" : "0 6 0");
          } else {
            tab.setAttribute("position", currentIndex === tabIndex ? "0 0.16 0.025" : "0 6.16 0.025");
          }
        }
      })


    };

    buttonLabels.forEach((label, index) => {
      const x = startX + index * (buttonWidth + spacing);
      const position = `${x} ${startY} ${z}`;

      const button = document.createElement("a-entity");
      button.setAttribute("ui-button", {
        label: label,
        type: "rounded-box",
        width: buttonWidth,
        height: buttonHeight,
        depth: 0.02,
        colorScheme: "primary",
        autosize: false,
        isSelectable: true,
        radius: 0.02,
        preferredFontSize: 0.033,
      });
      anchor.appendChild(button);
      button.setAttribute("position", position);
      button.setAttribute("data-raycastable", "");
      button.setAttribute("data-label", label);

      this.topMenuButtons.push(button);

      button.addEventListener("click", () => {
        selectButton(button, index)
        
        const prettyGEventName = ['LiveChartTab', 'PerformanceTab', 'ProfileTab', 'FinancialsTab']
        if (window.gtag) gtag('event', `VR_RightPanel_${prettyGEventName[index]}`);
      });
    });

    const defaultButton = this.topMenuButtons[0];
    if (defaultButton) {
      setTimeout(() => selectButton(defaultButton, 0), 200);
    }
  },

  createRightConfigurePopup: function () {
    const popup = document.createElement("a-entity");
    popup.setAttribute("id", "right-configure-popup");
    popup.setAttribute("right-configure-popup", "");
    popup.setAttribute("visible", false);
    popup.setAttribute("position", "-0.04 2.650 -0.800");
    popup.setAttribute("rotation", "0 0 0");
    popup.setAttribute("scale", "1.5 1.5 1");

    document.querySelector("a-scene #scene-wrapper").appendChild(popup);

    this.popupEl = popup;
    
    if (window.PopupManager) {
        window.PopupManager.register('right-configure-popup', popup);
    }
  },

  createFullscreenButton: function () {
    const anchor = this._getAnchor();

    const btn = document.createElement("a-entity");
    btn.setAttribute("ui-button", {
      image: "/vr-assets/right-container-buttons/fullscreen.png",
      width: 0.10,
      height: 0.10,
      depth: 0.02,
      type: "rounded-box",
      colorScheme: "primary",
      radius: 0.015,
    });
    anchor.appendChild(btn);
    btn.setAttribute("position", "0.54 0.53 0.03");
  },

  _toggleRightConfigurePopup: function () {
    if (window.PopupManager) {
        window.PopupManager.toggle('right-configure-popup');
        return;
    }

    const popup = this.popupEl;
    if (!popup) return;
    const newOpen = !popup.getAttribute("visible");
    popup.setAttribute("visible", newOpen);

    if (newOpen) {
      if (popup.components['right-configure-popup']?.onOpen) {
        popup.components['right-configure-popup'].onOpen();
      }
    }
  },

  initializeStoredChartType: function () {
    try {
      const stored = this._loadRightConfigureSettings();
      if (stored && stored.chartType) {
        console.log('Loading stored chart type:', stored.chartType);
        const popup = this.popupEl;
        if (popup && popup.components['right-configure-popup']) {
          popup.setAttribute('right-configure-popup', 'chartType', stored.chartType);
        }
      }
    } catch (e) {
      console.warn('Failed to initialize stored chart type:', e);
    }
  },

  _loadRightConfigureSettings: function () {
    try {
      return getCacheItem('rightConfigurePopupSettings');
    } catch (e) {
      console.warn('Failed to load right configure popup settings', e);
      return null;
    }
  },

  initializeDefaultChart: function () {
    try {
      const stockChart = document.getElementById('stock-chart');
      if (!stockChart) {
        console.log('No default stock-chart found');
        return;
      }

      const stored = this._loadRightConfigureSettings();
      const chartType = stored?.chartType || 'Mountain';
      const chartMathFunction = stored?.chartMathFunction || 'Linear';
      console.log('Initializing default chart with type:', chartType, stored);
      if (stockChart.hasAttribute('tradingview-universal-chart')) stockChart.removeAttribute('tradingview-universal-chart');
      if (stockChart.hasAttribute('tradingview-mountain-chart')) stockChart.removeAttribute('tradingview-mountain-chart');
      if (stockChart.hasAttribute('tradingview-line-chart')) stockChart.removeAttribute('tradingview-line-chart');
      if (stockChart.hasAttribute('tradingview-candlestick-chart')) stockChart.removeAttribute('tradingview-candlestick-chart');
      if (stockChart.hasAttribute('stock-candlestick-chart')) stockChart.removeAttribute('stock-candlestick-chart');

      if (chartType === 'Candlestick') {
        stockChart.setAttribute('tradingview-universal-chart', {
          stockData: JSON.stringify({
            ticker: "SPY",
            todaysChangePerc: 0.5,
            day: { c: 20000, v: 1000000 },
            tickerDetails: {
              name: "SPDR S&P 500 ETF Trust",
              primary_exchange: "NYSE"
            }
          }),
          dataInterval: "1d",
          width: 640,
          height: 480,
          type: 'candlestick',
          position: '-0.8 0 -0.48',
          chartMathFunction
        });
      } else if (chartType === 'Line') {
        stockChart.setAttribute('tradingview-universal-chart', {
          stockData: JSON.stringify({
            ticker: "SPY",
            todaysChangePerc: 0.5,
            day: { c: 20000, v: 1000000 },
            tickerDetails: {
              name: "SPDR S&P 500 ETF Trust",
              primary_exchange: "NYSE"
            }
          }),
          dataInterval: "1d",
          width: 640,
          height: 480,
          type: 'line',
          position: '-0.8 0 -0.48',
          chartMathFunction
        });
      } else {
        stockChart.setAttribute('tradingview-universal-chart', {
          stockData: JSON.stringify({
            ticker: "SPY",
            todaysChangePerc: 0.5,
            day: { c: 20000, v: 1000000 },
            tickerDetails: {
              name: "SPDR S&P 500 ETF Trust",
              primary_exchange: "NYSE"
            }
          }),
          dataInterval: "1d",
          width: 640,
          height: 480,
          type: 'mountain',
          position: '-0.8 0 -0.48',
          chartMathFunction
        });
      }

      console.log('Default chart initialized with type:', chartType);
    } catch (e) {
      console.warn('Failed to initialize default chart:', e);
    }
  },
  setThemeChangeListener: function () {
    const self = this;
    this.el.sceneEl.addEventListener('theme-changed', (event) => {
      this.themeMode = event.detail.themeMode;
      self.applyTheme()
    })
  },
  applyTheme: function () {
    const bgPanelLight = this.el.querySelector('.background-panel-light')
    const bgPanelDark = this.el.querySelector('.background-panel-dark')
    const bgModel = this.el.querySelector('.bg-model')
    console.log('setThemeChangeListener', bgPanelLight, bgPanelDark)

    if (this.themeMode === 'Dark') {
      if (bgPanelLight) bgPanelLight.setAttribute('visible', false);
      if (bgPanelDark) bgPanelDark.setAttribute('visible', true);
      if (bgModel) {
        bgModel.setAttribute('visible', true);
        bgModel.setAttribute('gltf-model', '#side-panel-dark-model');
      }
    } else {
      if (bgPanelDark) bgPanelDark.setAttribute('visible', false);
      if (bgPanelLight) bgPanelLight.setAttribute('visible', true);
      if (bgModel) bgModel.setAttribute('visible', false);
    }

    if (this.noDataTextEl) {
      this.noDataTextEl.setAttribute('color', this.themeMode === 'Light' ? '#1A1A1A' : '#FFFFFF');
    }
  },

  createNoDataMessage: function () {
    const liveChartTab = this.el.querySelector('.live-chart-tab');
    if (!liveChartTab) return;

    const text = document.createElement('a-troika-text');
    text.setAttribute('id', 'no-data-available-message');
    text.setAttribute('visible', false);
    text.setAttribute('position', '0.005 0.02 0.06');
    text.setAttribute('font-size', '0.01');
    text.setAttribute('color', this.themeMode === 'Light' ? '#1A1A1A' : '#FFFFFF');
    text.setAttribute('align', 'center');
    text.setAttribute('font-weight', 'bold');

    liveChartTab.appendChild(text);

    this.noDataMessageEl = text;
    this.noDataTextEl = text;
  },

  setupDataListeners: function () {
    const scene = this.el.sceneEl || document.querySelector('a-scene');
    if (!scene) return;

    scene.addEventListener('chart-data-fetch-complete', (evt) => {
      const { pointCount } = evt.detail;
      this.handleDataAvailability(pointCount > 0);
    });

    scene.addEventListener('chart-data-fetch-error', () => {
      this.handleDataAvailability(false);
    });

    scene.addEventListener('stock-selected', () => {
      this.hasClickedStock = true;
      this.handleDataAvailability(true);
    });

    scene.addEventListener('chart-data-fetch-started', () => {
      this.handleDataAvailability(true);
    });
  },

  handleDataAvailability: function (hasData) {
    if (!this.noDataMessageEl) return;

    if (hasData) {
      this.noDataMessageEl.setAttribute('visible', false);
    } else {
      const dateStr = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date());
      const msg = `${dateStr} data not available yet`;

      if (this.noDataTextEl) {
        this.noDataTextEl.setAttribute('value', msg);
      }

      const xPos = this.hasClickedStock ? 0.025 : 0.005;
      this.noDataMessageEl.setAttribute('position', `${xPos} 0.02 0.06`);

      this.noDataMessageEl.setAttribute('visible', true);
    }
  },

});

console.log("[right-container-control] component registered");
